/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import HomeScreen from '@/screens/home/HomeScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const HomeNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="HomeScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="HomeScreen"
        component={HomeScreen}
        options={{
          title: setTitleHeader('Dashboard'),
        }}
      />
    </Stack.Navigator>
  );
};

export default HomeNavigator;
